import { render, staticRenderFns } from "./MyAccount40Footer.vue?vue&type=template&id=f7c14b20&scoped=true&"
import script from "./MyAccount40Footer.vue?vue&type=script&lang=js&"
export * from "./MyAccount40Footer.vue?vue&type=script&lang=js&"
import style0 from "./MyAccount40Footer.vue?vue&type=style&index=0&id=f7c14b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c14b20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VFlex,VFooter,VLayout})
